import { iconOptions } from '@/components/icons/IconOptions'
import { createRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
import { FormContentV2 } from '@/unity-apps/components/component-library/FormComponent/FormContentV2'
import { InferFormValues, JsonFormSchemaV2 } from '@/unity-apps/components/component-library/FormComponent/types'

type MessagesLandingMenuItem = RestSchemas['Messages.Landing.MenuItem']

type MenuItemFormProps = {
  onSubmit: (data: InferFormValues<JsonFormSchemaV2>) => void
  initialValues?: Omit<MessagesLandingMenuItem, 'items'>
  showIcon?: boolean
  closeSheetOnSubmit?: boolean
  // availableRoles: { roleId: number; roleName: string; roleDescription: string }[]
  // availablePages: { label: string; value: string }[]
  // isPagesPending?: boolean
  // parentItem?: MessagesLandingMenuItem
}

export const MenuItemForm = ({
  onSubmit,
  initialValues,
  showIcon,
  closeSheetOnSubmit,
  // availableRoles,
  // availablePages,
  // parentItem,
}: MenuItemFormProps) => {
  const appId = useGetSearchParam<number>('appId')

  const { getApplicationsApiListApplicationRoles, getUiApiGetPages } = createRestClient()

  const {
    data: availablePages,
    isError: availablePagesError,
    isPending: availablePagesPending,
  } = getUiApiGetPages.useQuery(
    {
      path: { applicationId: appId! },
    },
    {
      select: (data) => data.filter((page) => Boolean(page.page)).map((page) => page.page as string),
    }
  )

  const {
    data: fetchedRoles,
    isError: fetchedRolesError,
    isPending: fetchedRolesPending,
  } = getApplicationsApiListApplicationRoles.useQuery(
    {
      query: { applicationId: appId },
    },
    {
      select: (data) =>
        // data.map((role) => ({
        //   title: role.name,
        //   value: String(role.id),
        // })),
        data.map((role) => role.name),
    }
  )

  if (!appId) {
    return <div>No app ID</div>
  }

  if (availablePagesPending || fetchedRolesPending) {
    return <div>Loading...</div>
  }

  if (availablePagesError || fetchedRolesError) {
    return <div>Error</div>
  }

  const required = ['item_type', 'name', 'page_id', 'description']

  const formSchema: JsonFormSchemaV2 = {
    type: 'object',
    required: showIcon ? [...required, 'icon_name'] : required,
    properties: [
      {
        id: 'item_type',
        type: 'string',
        title: 'Item Type',
        default: 'menu_item',
        readonly: true,
      },
      {
        id: 'name',
        type: 'string',
        title: 'Name',
        default: initialValues?.name ?? '',
      },
      {
        id: 'description',
        type: 'string',
        title: 'Description',
        widget: 'textarea',
        default: initialValues?.description ?? '',
      },
      {
        id: 'page_id',
        type: 'string',
        title: 'Page ID',
        choices: availablePages,
        default: initialValues?.page_id ?? '',
      },
      {
        id: 'icon_name',
        type: 'string',
        title: 'Icon',
        choices: [...iconOptions, ''],
        readonly: !showIcon,
        default: initialValues?.icon_name ?? '',
      },
      {
        id: 'assignedRoles',
        type: 'array',
        title: 'Assigned Roles',
        default: initialValues?.roles ?? [],
        items: {
          type: 'string',
          choices: fetchedRoles,
          widget: 'multiselect',
        },
        // default: initialValues?.assignedRoles ?? [],
      },
    ],
  }

  return (
    <FormContentV2
      schema={formSchema}
      submitHandler={onSubmit}
      closeSheetOnSubmit={closeSheetOnSubmit}
      className="space-y-5"
    />
  )
}
